import { render, staticRenderFns } from "./VSvgIcon.vue?vue&type=template&id=2e264f2a&"
import script from "./VSvgIcon.vue?vue&type=script&lang=js&"
export * from "./VSvgIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports